import * as React from 'react';
import type { JobOpportunitiesSectionBlockViewModel } from '../ViewModel/JobOpportunitiesSectionBlockViewModel.csharp';
import { JobOpportunitiesSection } from '~/Features/StudyPage/Campus/Sections/JobOpportunitiesSection/JobOpportunitiesSection';

export const JobOpportunitiesSectionBlock: React.FC<JobOpportunitiesSectionBlockViewModel> = props => {
    const { teaser, linkList, featuredArticle, blockVariant, ...otherProps } = props;

    return (
        <JobOpportunitiesSection
            {...otherProps}
            featuredArticle={
                featuredArticle && {
                    articleUrl: featuredArticle.url,
                    title: featuredArticle.title,
                    description: featuredArticle.description,
                    image: featuredArticle.image,
                }
            }
            variant={blockVariant}
            studyPageLinkList={{
                items: linkList,
                teaser,
            }}
        />
    );
};
